export default function getStatusColor(
  status: number | string
): 'danger' | 'warning' | 'success' | 'secondary' | 'info' | undefined {
  switch (status) {
    case 'open':
      return 'info';
    case 2:
    case 3:
    case 'cancelled':
    case 'depleting':
    case 'expenditure':
    case 'owing':
      return 'danger';
    case 4:
    case 5:
    case 6:
    case 'Busy':
    case 'Delayed':
    case 'In progress':
    case 'Processing':
    case 'partiallyFulfilled':
    case 'Unavailable':
      return 'warning';
    case 7:
    case 8:
    case 9:
    case 10:
    case 'Available':
    case 'additive':
    case 'Completed':
    case 'fulfilled':
    case 'inflow':
    case 'On Schedule':
    case 'Online':
    case 'Paid':
    case 'restocked':
    case 'returned':
    case 'Reviewed':
    case 'Shipped':
      return 'success';
    case 'Offline':
    case 'Outstanding':
      return 'secondary';
    default:
      return undefined;
  }
}
